// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Messages_wrapper__WtvY5","imageContainer":"Messages_imageContainer__0XA89","link":"Messages_link__jvCuP"};